import {createSelector} from 'reselect';

import {featureFlagsSelector} from '../../../store/gsConfig/selectors';
import FEATURE_FLAGS from '../../../utils/featureFlags';

export const showTrustMessagesSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features[FEATURE_FLAGS.common.trustMessages]
);
